<dcl-modal
    class="quick-quote-modal"
    [open]="open"
    [attr.aria-label]="getAriaLabel()"
    #modal
    fullscreen
    block-focus
    hide-close-icon
    prevent-focus-body>
    <div #header slot="title" class="quick-quote-modal-header">
        <span class="quick-quote-modal-header__title">{{ titleLabel | translate }}</span>
    </div>
    <div #body slot="body" class="quick-quote-modal-content">
        <button class="quick-quote-modal-header__button quick-quote-modal-header__button--close"
            #closeButton
            [attr.aria-label]="(titleLabel | translate) + ' ' + (constants.translationKeys.modal.buttonClose | translate)"
            (click)="closeModal()"
            *ngIf="!filterSelected">
            <i class="di di-close-reversed"></i>
        </button>
        <button class="quick-quote-modal-header__button quick-quote-modal-header__button--close"
            #closeButton
            [attr.aria-label]="getAriaLabel(true)"
            [attr.aria-live]="isIOS ? 'polite' : null"
            (click)="cancelFilterSelections()"
            *ngIf="filterSelected">
            <i class="di di-previous-2"></i>
        </button>
        <button
            *ngIf="filterSelected && filterSelected.type !== constants.filters['travel-party'].id"
            class="quick-quote-modal-header__button quick-quote-modal-header__button--clear"
            [attr.aria-label]="constants.translationKeys.modal.buttonClearAria | translate"
            (click)="clearFiltersByType()"
            translate>
            {{ constants.translationKeys.modal.buttonClear }}
        </button>
        <ng-container [ngTemplateOutlet]="filterSelected ? filterSelectedContent : allFiltersContent"></ng-container>
        <button
            *ngIf="!filterSelected"
            (click)="clearAllFilters()"
            class="quick-quote-modal-content__button"
            translate>
            {{ constants.translationKeys.modal.buttonClearAll }}
        </button>
    </div>
    <div #footer slot="buttons" class="quick-quote-modal-footer">
        <wdpr-button
            [attr.aria-label]="buttonLabel | translate"
            [disabled]="isButtonDisabled()"
            (click)="onButtonClick()"
            (touchstart)="onButtonClick()"
            (keyup.enter)="onButtonClick()">
            {{ buttonLabel | translate }}
        </wdpr-button>
    </div>
</dcl-modal>

<ng-template #allFiltersContent>
    <ng-container *ngFor="let filter of filtersData">
        <ng-container *ngIf="!filter.isSubgroup">
            <div class="card"
                (keyup.enter)="setFilterSelected(filter.type)"
                (click)="setFilterSelected(filter.type)"
                tabindex="0"
                role="button">
                <div class="card-text-wrapper">
                    <span class="card-text-wrapper__filter-name" translate>{{ filter.headingKey }}</span>
                    <span class="card-text-wrapper__filter-value" *ngIf="filter.modalValue">
                        {{ filter.modalValue | translate }}
                    </span>
                </div>
                <div class="card-icon-wrapper">
                    <i class="di di-next-2"></i>
                </div>
            </div>
            <hr tabindex="-1" class="separator" aria-hidden="true">
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #filterSelectedContent>
    <dcl-quick-quote-filter-wrapper
        [filterDataSubGroup]="filterDataSubGroup"
        [filterData]="filterSelected"
        [showClearBtn]="showClearBtn"
        [showFilterType]="showFilterType">
    </dcl-quick-quote-filter-wrapper>
</ng-template>
